import http from '../../../common/axios/axios.instance';

/**
 * Post a comment to an offer
 * @param {number} offerId - The offer ID
 * @param {Object} commentData - Comment data
 * @param {number} commentData.rate - Rating (1-5) - REQUIRED
 * @param {string} commentData.body - Comment text - REQUIRED (can be empty string)
 * @param {string} commentData.authorName - Author name (for non-authenticated users only)
 * @returns {Promise} API response
 *
 * Example body:
 * Authenticated user: { "rate": 5, "body": "Zo'r" }
 * Non-authenticated: { "rate": 5, "body": "Zo'r", "authorName": "Mansur" }
 */
export const postCommentApi = (offerId, commentData) => {
  // Ensure body structure matches API requirements
  const payload = {
    rate: commentData.rate,
    body: commentData.body || '', // Body is required, use empty string if not provided
  };

  // Add authorName only if provided (for non-authenticated users)
  if (commentData.authorName) {
    payload.authorName = commentData.authorName;
  }

  return http.post(`/api/v1/offers/comment/${offerId}`, payload).then((response) => {
    return response.data;
  });
};
